/* ==========================================================================
   GOO GOO — print script                      (Shopify asset: assets/print.js)
   --------------------------------------------------------------------------
   Printing itself is driven entirely by assets/print.css (@media print):
   the real page is what prints. This file only clears obstacles:

   1. Deletes any leftover ".print-snapshot" clone — the previous mechanism that
      produced a totally blank sheet whenever the clone was not ready in time.

   2. Guards <body> against a print-time page wipe. Content-protection scripts
      (here: the NoSpy Protect Data app, whose setting `web_page_print` is
      currently false = print protection active) blank the storefront inside a
      `beforeprint` handler:

          window[random] = document.body.innerHTML;
          document.body.innerHTML = "<p><pretecting</p>";

      ...so that Ctrl+P yields an empty sheet. That is the direct cause of the
      blank printout on this store. The guard ignores a "wipe" assignment and
      ignores body rewrites while the print dialog is open, but leaves every
      other assignment untouched — the live page stays fully interactive after
      the print dialog closes.

   If you switch off print protection inside that app instead, this guard never
   fires and can be deleted without affecting the print layout.
   ========================================================================== */

(function () {
  'use strict';

  function removePrintSnapshots() {
    var nodes = document.querySelectorAll('.print-snapshot');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) {
        nodes[i].parentNode.removeChild(nodes[i]);
      }
    }
  }

  removePrintSnapshots();
  window.addEventListener('beforeprint', removePrintSnapshots);
  window.addEventListener('afterprint', removePrintSnapshots);

  var printDialogOpen = false;
  window.addEventListener('beforeprint', function () {
    printDialogOpen = true;
  });
  window.addEventListener('afterprint', function () {
    printDialogOpen = false;
  });

  try {
    var body = document.body;
    var descriptor =
      window.Element && Element.prototype
        ? Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML')
        : null;

    if (body && descriptor && descriptor.get && descriptor.set) {
      var WIPE_MAX_LENGTH = 500;

      Object.defineProperty(body, 'innerHTML', {
        configurable: true,
        enumerable: false,
        get: function () {
          return descriptor.get.call(this);
        },
        set: function (value) {
          var hasRealContent = this.childNodes.length > 3;
          var looksLikeWipe =
            typeof value === 'string' && value.length <= WIPE_MAX_LENGTH;

          if (hasRealContent && (looksLikeWipe || printDialogOpen)) {
            return;
          }
          descriptor.set.call(this, value);
        }
      });
    }
  } catch (error) {
    /* a broken guard must never break the storefront */
  }
})();
